<form [formGroup]="formGroup"
  (ngSubmit)="save()">
  @if (users$ | async; as users) {
    <ion-item lines="none"
      button="true"
      (click)="selectUser(users)">
      @if (selectedTo().length > 0) {
        @for (user of selectedTo(); track user.guid) {
          <span class="user">{{ user.name }}</span>
        }
      } @else {
        {{ 'general.select' | translate }}
      }
    </ion-item>
  } @else {
    <app-loading></app-loading>
  }
  <h3>{{ 'feedback.text' | translate }}</h3>
  <ion-item lines="none">
    <ion-textarea autocapitalize="on"
      formControlName="feedback"
      rows="14"
      autocapitalize="true"></ion-textarea>
  </ion-item>
  <div class="ion-margin-top">
    <ion-button color="light"
      shape="round"
      type="submit"
      [disabled]="!formGroup.valid || selectedTo().length === 0">{{ 'general.send' | translate }}</ion-button>
  </div>
</form>